import {
  clearAdminSession,
  getAdminToken,
} from "./adminAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_ADMIN_API_BASE_URL ||
  "http://secondbite-manage.localhost/admin-api/v1"
).replace(/\/+$/, "");

const request = async (path, options = {}) => {
  let response;

  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getAdminToken()}`,
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...options.headers,
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  const payload = await response.json().catch(() => null);

  if (response.status === 401) {
    clearAdminSession();
    window.location.replace("/login");
    throw new Error("Your session has expired.");
  }

  if (!response.ok || !payload?.success) {
    const validationMessage = payload?.errors
      ? Object.values(payload.errors).flat().find(Boolean)
      : null;
    throw new Error(validationMessage || payload?.message || "Request failed.");
  }

  return payload;
};

export const listAdminUsers = async ({ status = "", keyword = "" } = {}) => {
  const params = new URLSearchParams({ per_page: "100" });

  if (status !== "") params.set("status", status);
  if (keyword.trim()) params.set("keyword", keyword.trim());

  return (await request(`/administrators?${params}`)).data;
};

export const getAdminUserMeta = async () =>
  (await request("/administrators/meta")).data;

export const getAdminUser = async (id) =>
  (await request(`/administrators/${id}`)).data;

export const createAdminUser = async (data) =>
  (await request("/administrators", {
    method: "POST",
    body: JSON.stringify(data),
  })).data;

export const updateAdminUser = async (id, data) =>
  (await request(`/administrators/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  })).data;
